/** Contact form checks and the WhatsApp message opened from the contact page. */

const INDIAN_MOBILE = /^[6-9]\d{9}$/;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const localIndianMobile = (value) => {
  const digits = String(value || '').replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('91')) return digits.slice(2);
  if (digits.length === 11 && digits.startsWith('0')) return digits.slice(1);
  return digits;
};

const validateContactForm = (fields) => {
  const name = String(fields.name || '').trim();
  const mobile = String(fields.mobile || '').trim();
  const email = String(fields.email || '').trim();
  const subject = String(fields.subject || '').trim();
  const message = String(fields.message || '').trim();
  const errors = {};

  if (!name) errors.name = 'Enter your name.';
  if (!mobile) errors.mobile = 'Enter your mobile number.';
  else if (!INDIAN_MOBILE.test(localIndianMobile(mobile))) {
    errors.mobile = 'Enter a valid 10-digit Indian mobile number.';
  }
  if (email && !EMAIL_PATTERN.test(email)) errors.email = 'Enter a valid email address, or leave it blank.';
  if (!subject) errors.subject = 'Enter a subject.';
  if (!message) errors.message = 'Enter your message.';

  return {
    ok: Object.keys(errors).length === 0,
    errors,
    values: { name, mobile, email, subject, message },
  };
};

const buildContactWhatsAppMessage = ({ name, mobile, email, subject, message }) => {
  const lines = [
    'Hello EasyDropTaxi,',
    '',
    'I would like to contact you.',
    '',
    `Name: ${name}`,
    `Mobile: ${mobile}`,
  ];
  if (email) lines.push(`Email: ${email}`);
  lines.push(`Subject: ${subject}`, '', 'Message:', message);
  return lines.join('\n');
};

const buildContactWhatsAppUrl = (whatsappNumber, fields) => {
  const text = buildContactWhatsAppMessage(fields);
  return `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`;
};

module.exports = {
  validateContactForm,
  buildContactWhatsAppMessage,
  buildContactWhatsAppUrl,
};
